import { render, staticRenderFns } from "./singleSuccessView.vue?vue&type=template&id=1bc87546&"
import script from "./singleSuccessView.vue?vue&type=script&lang=js&"
export * from "./singleSuccessView.vue?vue&type=script&lang=js&"
import style0 from "./singleSuccessView.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports